module.exports = __webpack_public_path__ + "img/usuarios_2.41433263.svg";